import ApplicationController from './application_controller'
import $ from 'jquery'
import 'select2'
import 'select2/dist/css/select2.css'
import 'select2-bootstrap-5-theme/dist/select2-bootstrap-5-theme.css'

// Context Switcher with Select2
// Manages switching between User, Organization, and Giving Day contexts
export default class extends ApplicationController {
  static targets = ["select"]

  static values = {
    currentEntityType: String,
    currentEntityId: Number
  }

  connect() {
    super.connect()
    console.log('Context switcher connected')
    console.log('jQuery available:', typeof $ !== 'undefined')
    console.log('jQuery.fn.select2 available:', typeof $.fn.select2 !== 'undefined')
    console.log('Select target:', this.selectTarget)

    // Get brand color from data attribute
    // Note: HAML data: {brand_color: ...} may become data-brand_color or data-brand-color
    console.log('Context switcher element:', this.element)
    console.log('Element dataset (all keys):', Object.keys(this.element.dataset))
    console.log('dataset.brandColor:', this.element.dataset.brandColor)
    console.log('dataset.brand_color:', this.element.dataset.brand_color)
    // Try both camelCase and snake_case versions
    this.brandColor = this.element.dataset.brandColor || this.element.dataset.brand_color || '#17a2b8'
    console.log('Brand color being used:', this.brandColor)

    // Add click handler to debug
    $(this.selectTarget).on('click', function() {
      console.log('Select element clicked')
    })

    this.initializeContextSwitcher()
  }

  // Helper to lighten a hex color
  lightenColor(hex, percent) {
    hex = hex.replace('#', '')
    const r = parseInt(hex.substring(0, 2), 16)
    const g = parseInt(hex.substring(2, 4), 16)
    const b = parseInt(hex.substring(4, 6), 16)

    const newR = Math.min(255, Math.floor(r + (255 - r) * percent))
    const newG = Math.min(255, Math.floor(g + (255 - g) * percent))
    const newB = Math.min(255, Math.floor(b + (255 - b) * percent))

    return `#${newR.toString(16).padStart(2, '0')}${newG.toString(16).padStart(2, '0')}${newB.toString(16).padStart(2, '0')}`
  }

  disconnect() {
    $(this.selectTarget).select2('destroy')
  }

  initializeContextSwitcher() {
    const self = this

    $(this.selectTarget).select2({
      theme: 'bootstrap-5',
      width: '100%',
      placeholder: 'Select context...',
      minimumResultsForSearch: 3, // Show search when 3+ items
      templateResult: this.formatOption.bind(this),
      templateSelection: this.formatSelection.bind(this),
      closeOnSelect: true,
      // Sort results to maintain group order
      sorter: function(data) {
        return data
      }
    })

    // Log when dropdown opens
    $(this.selectTarget).on('select2:open', function(e) {
      console.log('Dropdown opened')

      // Focus the search field immediately using Select2's container
      // Use requestAnimationFrame to ensure DOM is ready
      requestAnimationFrame(() => {
        const searchField = document.querySelector('.select2-container--open .select2-search__field')
        if (searchField) {
          searchField.focus()
        }
      })

      // Get the dropdown container and set width
      setTimeout(() => {
        const $dropdown = $('.select2-dropdown')
        console.log('Dropdown found:', $dropdown.length)
        if ($dropdown.length) {
          $dropdown.css({
            'width': '400px',
            'max-width': '90vw',
            'display': 'block',
            'visibility': 'visible'
          })

          // Add section-specific classes to optgroups based on label text
          const brandColor = self.brandColor
          console.log('Assigning section classes. Brand color:', brandColor)
          $dropdown.find('.select2-results__group').each(function() {
            const $group = $(this)
            const label = $group.text().trim().toLowerCase()
            const $groupContainer = $group.closest('.select2-results__option[role="group"]')

            console.log('Group label:', label)
            console.log('Group container element:', $groupContainer[0])

            // Remove any existing section classes
            $groupContainer.removeClass('section-community-hubs section-nonprofit-profiles section-givsum-dashboard section-personal')

            // Use a lighter version of brand color for headers (visible on dark bg)
            const headerColor = self.lightenColor(brandColor, 0.3)

            // Add appropriate section class based on label
            if (label.includes('community hubs') || label.includes('giving days')) {
              console.log('-> Adding section-community-hubs')
              $groupContainer.addClass('section-community-hubs')
              // Set header color to lighter brand color for visibility
              $group.css('color', headerColor)
            } else if (label.includes('nonprofit profiles')) {
              console.log('-> Adding section-nonprofit-profiles')
              $groupContainer.addClass('section-nonprofit-profiles')
              // Set header color to lighter brand color for visibility
              $group.css('color', headerColor)
            } else if (label.includes('givsum dashboard') || label.includes('operations')) {
              console.log('-> Adding section-givsum-dashboard')
              $groupContainer.addClass('section-givsum-dashboard')
            } else if (label.includes('personal')) {
              console.log('-> Adding section-personal')
              $groupContainer.addClass('section-personal')
            } else {
              console.log('-> No matching section for label:', label)
            }
          })

          // Add hover handlers to selectable options
          console.log('Setting up hover handlers with brandColor:', brandColor)
          const brandColorLight = self.lightenColor(brandColor, 0.5)
          console.log('Brand color light:', brandColorLight)
          // Givsum colors
          const givsumOrange = '#EE6840'
          const givsumOrangeLight = self.lightenColor(givsumOrange, 0.4)
          const givsumTeal = '#157f83'
          const givsumTealLight = self.lightenColor(givsumTeal, 0.5)

          $dropdown.find('.select2-results__option--selectable').each(function() {
            const $option = $(this)
            const optionText = $option.text().trim()
            const $groupContainer = $option.closest('.select2-results__option[role="group"]')

            // Find the group header text for this option
            const groupHeaderText = $groupContainer.find('.select2-results__group').first().text().trim()

            // Determine which section this option belongs to
            let hoverBg = brandColor
            let hoverText = brandColorLight

            const groupClasses = $groupContainer.attr('class')
            console.log('Option:', optionText, '| Group header:', groupHeaderText, '| Group classes:', groupClasses)

            if ($groupContainer.hasClass('section-givsum-dashboard')) {
              hoverBg = givsumOrange
              hoverText = givsumOrangeLight
              console.log('Using Givsum orange for hover')
            } else if ($groupContainer.hasClass('section-personal')) {
              hoverBg = givsumTeal
              hoverText = givsumTealLight
              console.log('Using Givsum teal for hover')
            } else {
              // Community Hubs & Nonprofit Profiles use brand color
              hoverBg = brandColor
              hoverText = brandColorLight
              console.log('Using brand color for hover:', hoverBg)
            }

            $option.off('mouseenter.hoverActive mouseleave.hoverActive')

            $option.on('mouseenter.hoverActive', function() {
              $(this).addClass('hover-active')
              // Use style attribute directly to override CSS !important rules
              this.style.setProperty('background-color', hoverBg, 'important')
              $(this).find('.entity-name').each(function() {
                this.style.setProperty('color', hoverText, 'important')
              })
              $(this).find('.entity-type').each(function() {
                this.style.setProperty('color', hoverText, 'important')
              })
            })

            $option.on('mouseleave.hoverActive', function() {
              $(this).removeClass('hover-active')
              this.style.removeProperty('background-color')
              $(this).find('.entity-name').each(function() {
                this.style.removeProperty('color')
              })
              $(this).find('.entity-type').each(function() {
                this.style.removeProperty('color')
              })
            })
          })
        }
      }, 50)
    })

    // Handle context switch
    $(this.selectTarget).on('select2:select', function(e) {
      const data = e.params.data
      const $option = $(data.element)
      const url = $option.data('url')
      const entityValue = $option.val() // This is "type-id" format

      console.log('Context switch triggered')
      console.log('Option element:', data.element)
      console.log('URL from data attribute:', url)
      console.log('Entity value:', entityValue)
      console.log('All data attributes:', $option.data())

      if (url && entityValue) {
        // Set cookie before navigation
        document.cookie = `entity=${entityValue}; path=/; max-age=31536000`
        console.log('Setting cookie:', `entity=${entityValue}`)
        console.log('Navigating to:', url)
        window.location.href = url
      } else {
        console.log('Missing url or entityValue - not navigating')
        console.log('url:', url)
        console.log('entityValue:', entityValue)
      }
    })
  }

  // Format options in dropdown
  formatOption(option) {
    if (!option.element) return option.text

    // Don't format optgroup labels
    if (option.children) {
      return option.text
    }

    const $option = $(option.element)
    const avatarUrl = $option.data('avatar')
    const entityType = $option.data('entity-type')
    const badge = $option.data('badge')

    let html = '<div class="entity-option d-flex align-items-center">'

    // Avatar
    if (avatarUrl) {
      html += `<div class="entity-avatar me-2">
                <img src="${avatarUrl}" class="rounded-circle" width="32" height="32" alt="${option.text}">
              </div>`
    }

    // Name and type
    html += '<div class="entity-info flex-grow-1">'
    html += `<div class="entity-name">${option.text}</div>`

    // Only show entity type for current user (not in a group)
    if (entityType && entityType === 'user') {
      html += `<small class="entity-type text-muted">${this.formatEntityType(entityType)}</small>`
    }
    html += '</div>'

    // Badge (for child giving days)
    if (badge) {
      html += `<span class="badge bg-secondary ms-2">${badge}</span>`
    }

    html += '</div>'

    return $(html)
  }

  // Format selected option (compact view)
  formatSelection(option) {
    if (!option.element) return option.text

    const $option = $(option.element)
    const avatarUrl = $option.data('avatar')

    if (!avatarUrl) return option.text

    return $(`
      <div class="entity-selection d-flex align-items-center">
        <img src="${avatarUrl}" class="rounded-circle me-2" width="40" height="40" alt="${option.text}">
        <span>${option.text}</span>
      </div>
    `)
  }

  formatEntityType(type) {
    const types = {
      'user': 'Personal',
      'organization': 'Organization',
      'giving_day_master': 'Giving Day',
      'giving_day_child': 'Child Giving Day'
    }
    return types[type] || type
  }
}
